import { useDispatch } from "react-redux";
import { getPlans } from "../redux/slices/users";
import { useEnterprisePlansSelector } from "../redux/selector/users";
import { useGetLoadingSelector } from "../redux/selector/users";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";

import { updateSmallBusinessPlan } from "../redux/slices/users";
import swal from "sweetalert";

export const useHandleEnterprisePlans = () => {
  const enterprisePlansSelector = useEnterprisePlansSelector();
  const loading = useGetLoadingSelector();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getPlans());
  }, []);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [formData, setFormData] = useState({});
  const [additionalInfoItems, setAdditionalInfoItems] = useState([]);
  const [editingInfoItem, setEditingInfoItem] = useState(null);
  const [newInfoItem, setNewInfoItem] = useState({ info: "", is_bold: false });
  const [showAddForm, setShowAddForm] = useState(false);

  useEffect(() => {
    // Set the first plan as default selected when data is loaded
    if (
      enterprisePlansSelector &&
      enterprisePlansSelector.length > 0 &&
      !selectedPlan
    ) {
      setSelectedPlan(enterprisePlansSelector[0]);
    }
  }, [enterprisePlansSelector]);

  useEffect(() => {
    if (selectedPlan) {
      setFormData({
        name: selectedPlan.name || "",
        description: selectedPlan.description || "",
        one_year_cost: selectedPlan.one_year_cost || 0,
        later_cost: selectedPlan.later_cost || 0,
        total_users: selectedPlan.total_users || 0,
        price_id: selectedPlan.price_id || "enterprise test",
        dev_price_id: selectedPlan.dev_price_id || "enterprise test",
      });

      // Parse additional info from extra_data if it exists
      if (selectedPlan?.extra_data && selectedPlan?.extra_data) {
        setAdditionalInfoItems(selectedPlan?.extra_data);
      } else {
        setAdditionalInfoItems([]);
      }
    }
  }, [selectedPlan]);

  const handlePlanChange = (e) => {
    const planId = parseInt(e.target.value);
    const plan = enterprisePlansSelector.find((plan) => plan.id === planId);
    setSelectedPlan(plan);
    setEditMode(false);
    setEditingInfoItem(null);
    setShowAddForm(false);
  };

  const handleInputChange = (e) => {
    let { name, value } = e.target;

    setFormData({
      ...formData,

      [name]: value,
    });
  };

  const handleEditToggle = () => {
    setEditMode(!editMode);
    setEditingInfoItem(null);
    setShowAddForm(false);
  };

  const handleSave = () => {
    // Here you would dispatch an action to save the updated plan
    // For now, we'll just show a success message
    dispatch(
      updateSmallBusinessPlan({
        ...formData,
        extra_data: additionalInfoItems,
        id: selectedPlan?.id,
        type: 1,

        cb(res) {
          dispatch(getPlans());
          toast.success(res?.data?.msg);
        },
      })
    );
    setEditMode(false);

    // Update the selected plan with the form data and additional info items
    setSelectedPlan({
      ...selectedPlan,
      ...formData,
      extra_data: additionalInfoItems,
    });
  };

  // Additional info item handlers
  const handleAddInfoItem = () => {
    if (newInfoItem.info.trim() === "") {
      toast.error("Item text cannot be empty");
      return;
    }

    const newItem = {
      info: newInfoItem.info,
      is_bold: newInfoItem.is_bold,
    };

    setAdditionalInfoItems([...additionalInfoItems, newItem]);
    setNewInfoItem({ info: "", is_bold: false });
    setShowAddForm(false);
  };

  const handleDeleteInfoItem = (index) => {
    swal({
      text: "Are you sure you want to delete this item?",
      dangerMode: true,
      buttons: true,
    }).then((result) => {
      if (result) {
        const updatedItems = additionalInfoItems.filter(
          (_, infoIndex) => infoIndex !== index
        );
        setAdditionalInfoItems(updatedItems);
      }
    });
  };

  const handleEditInfoItem = (item, index) => {
    setEditingInfoItem({ ...item, index: index });
  };

  const handleUpdateInfoItem = () => {
    if (!editingInfoItem || editingInfoItem.info.trim() === "") {
      toast.error("Item text cannot be empty");
      return;
    }

    const updatedItems = additionalInfoItems.map((item, index) =>
      index === editingInfoItem?.index
        ? { info: editingInfoItem?.info, is_bold: editingInfoItem?.is_bold }
        : item
    );

    setAdditionalInfoItems(updatedItems);
    setEditingInfoItem(null);
  };

  const handleInfoItemChange = (e) => {
    setEditingInfoItem({
      ...editingInfoItem,
      info: e.target.value,
    });
  };

  const handleInfoItemBoldToggle = () => {
    setEditingInfoItem({
      ...editingInfoItem,
      is_bold: !editingInfoItem.is_bold,
    });
  };

  const handleNewInfoItemChange = (e) => {
    setNewInfoItem({
      ...newInfoItem,
      info: e.target.value,
    });
  };

  const handleNewInfoItemBoldToggle = () => {
    setNewInfoItem({
      ...newInfoItem,
      is_bold: !newInfoItem.is_bold,
    });
  };

  return {
    enterprisePlansSelector,
    loading,
    selectedPlan,
    editMode,
    formData,
    additionalInfoItems,
    editingInfoItem,
    newInfoItem,
    showAddForm,
    handlePlanChange,
    handleInputChange,
    handleEditToggle,
    handleSave,
    handleAddInfoItem,
    handleDeleteInfoItem,
    handleEditInfoItem,
    handleUpdateInfoItem,
    handleInfoItemChange,
    handleInfoItemBoldToggle,
    handleNewInfoItemChange,
    handleNewInfoItemBoldToggle,
    setEditingInfoItem,
    setShowAddForm,
  };
};
